"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[100],{

/***/ 100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50029);
/* harmony import */ var _home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27812);
/* harmony import */ var _home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77058);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DAO__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90793);
/* harmony import */ var _components_atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52738);
/* harmony import */ var _components_molecules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53732);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54176);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60651);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _profile_modals_MediaModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);
























var MediaListContainer = function MediaListContainer(props) {
  var profileId = props.profileId,
      item = props.item,
      category = props.category,
      subTabType = props.subTabType,
      isMobileVersion = props.isMobileVersion;
  var navigation = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var mediaModalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null); // const isFocus = useIsFocused();

  var isFocus = true;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(subTabType == "albums" ? 1 : 0),
      selectedTabIndex = _useState[0],
      setSelectedTabIndex = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      totalMediaCount = _useState2[0],
      setTotalMediaCount = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      totalAlbumCount = _useState3[0],
      setTotalAlbumCount = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      medias = _useState4[0],
      setMedias = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      albums = _useState5[0],
      setAlbums = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1),
      pageIndex = _useState6[0],
      setPageIndex = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoading = _useState7[0],
      setIsLoading = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      mediaModalSelected = _useState8[0],
      setMediaModalSelected = _useState8[1];

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var menuItems = [{
    title: category !== _config__WEBPACK_IMPORTED_MODULE_6__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? "".concat(t("key_media_mix")) : "".concat(t("key_media_all"), " ").concat(totalMediaCount) // ? `${t("key_media_mix")} ${totalMediaCount}`
    // : `${t("key_media_all")} ${totalMediaCount}`,

  }, {
    title: "".concat(t("key_media_albums"))
  }];
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (props.tabType == _config__WEBPACK_IMPORTED_MODULE_6__/* .Constants.profileTabType.TAB_MEDIA */ .gT.profileTabType.TAB_MEDIA) {
      loadData();
    }
  }, [isFocus, props.tabType]);

  var onRefresh = function onRefresh() {
    onLoadMedias();
  };

  var onLoadMore = function onLoadMore() {
    if (!isLoading) {
      onLoadMedias(pageIndex + 1);
    }
  };

  var onLoadMedias = function onLoadMedias(_pageIndex) {
    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    if (!profileId) return;
    setIsLoading(true);
    var params = {
      pageIndex: _pageIndex || 1,
      pageSize: pageSize,
      albumId: 1
    };

    if (profileId) {
      params.profileId = profileId;
    }

    _DAO__WEBPACK_IMPORTED_MODULE_3__/* .MediaDao.find */ .ch.find(params).then(function (result) {
      var _medias = [];

      if (params.pageIndex == 1) {
        _medias = result.data;
      } else {
        _medias = [].concat((0,_home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(medias), (0,_home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(result.data));
      }

      setMedias(_medias);
      setTotalMediaCount(result.totalCount);
      setPageIndex(params.pageIndex);
      setIsLoading(false);
    })["catch"](function (ex) {
      console.error("ex", ex);
      setIsLoading(false);
    });
  };

  var loadData = function loadData() {
    var params = {};

    if (profileId) {
      params.profileId = profileId;
    }

    onLoadMedias();
    _DAO__WEBPACK_IMPORTED_MODULE_3__/* .AlbumDao.find */ .Ee.find(params).then(function (result) {
      setAlbums(result.data.filter(function (x) {
        return x.id == _config__WEBPACK_IMPORTED_MODULE_6__/* .Constants.albumType.MIX */ .gT.albumType.MIX;
      }));
      setTotalAlbumCount(result.data.length);
    });
  };

  var _onSelectTab = function onSelectTab(index) {
    setSelectedTabIndex(index);
    navigation.replace({
      pathname: (0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .generateURLSlug */ .ZF)(item.id, item.title || item.displayName || item.nickname, item.startDate, category, "about"),
      hash: "media",
      query: {
        subTabType: index == 1 ? "albums" : "all"
      }
    });
  };

  var onAlbumItemAction = function onAlbumItemAction(type, item) {
    navigation.push({
      pathname: "/album/details",
      query: {
        profileId: profileId,
        albumId: item.id
      }
    });
  };

  var onOpenExternalLink = /*#__PURE__*/function () {
    var _ref = (0,_home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)( /*#__PURE__*/_home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
      var win;
      return _home_ubuntu_webApp_prefab_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              win = window.open(url, "_blank");
              win.focus();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onOpenExternalLink(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onMediaItemPress = function onMediaItemPress(type, item) {
    if (item.isLink && item.mediaType == _config__WEBPACK_IMPORTED_MODULE_6__/* .Constants.mediaType.MEDIA_TYPE_VIDEO */ .gT.mediaType.MEDIA_TYPE_VIDEO) {
      onOpenExternalLink(item.video);
    } else {
      var _mediaModalRef$curren;

      mediaModalRef === null || mediaModalRef === void 0 ? void 0 : (_mediaModalRef$curren = mediaModalRef.current) === null || _mediaModalRef$curren === void 0 ? void 0 : _mediaModalRef$curren.showModal();
      setMediaModalSelected(item); // const id = item.id;
      // const profileId = item.profileId;
      // const albumId = item.albumId;
      // navigation.push({
      //   pathname: "/media/details",
      //   query: {
      //     id: id,
      //     profileId: profileId,
      //     albumId: albumId,
      //   },
      // });
    }
  };

  var renderContent = function renderContent() {
    if (selectedTabIndex == 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .MediaGrid */ .sQ, {
        items: medias,
        style: {
          marginTop: isMobileVersion ? 8 : 16,
          marginBottom: 0
        },
        onItemAction: onMediaItemPress,
        onRefresh: onRefresh,
        onLoadMore: onLoadMore,
        isMobileVersion: isMobileVersion
      });
    } else {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .MediaGrid */ .sQ, {
        items: albums,
        isAlbum: true,
        style: {
          marginTop: isMobileVersion ? 8 : 16
        },
        onItemAction: onAlbumItemAction,
        isMobileVersion: isMobileVersion
      });
    }

    return null;
  };

  if (!profileId) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_16___default()), {
      style: [styles.container, props.style],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_4__/* .CTabSelector */ .Qv, {
        items: menuItems,
        selectedIndex: selectedTabIndex,
        tabItemType: "colored-round-tab",
        onSelectTab: function onSelectTab(item, index) {
          _onSelectTab(index);
        },
        containerStyle: {
          marginTop: 0,
          marginHorizontal: 0,
          paddingHorizontal: isMobileVersion ? 16 : 0
        },
        isMobileVersion: isMobileVersion
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_16___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_4__/* .CTabSelector */ .Qv, {
      items: menuItems,
      selectedIndex: selectedTabIndex,
      tabItemType: "colored-round-tab",
      onSelectTab: function onSelectTab(item, index) {
        _onSelectTab(index);
      },
      containerStyle: {
        marginTop: 18,
        marginHorizontal: 0,
        paddingHorizontal: isMobileVersion ? 16 : 0
      },
      isMobileVersion: isMobileVersion
    }), renderContent(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_profile_modals_MediaModal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      ref: mediaModalRef,
      item: mediaModalSelected,
      isMobileVersion: isMobileVersion,
      onPrev: function onPrev() {
        var selectedItemIndex = medias.filter(function (i) {
          return i.mediaType === "image";
        }).findIndex(function (i) {
          return i.id === (mediaModalSelected === null || mediaModalSelected === void 0 ? void 0 : mediaModalSelected.id);
        });
        var newIndex = selectedItemIndex - 1 < 0 ? medias.filter(function (i) {
          return i.mediaType === "image";
        }).length - 1 : selectedItemIndex - 1;
        setMediaModalSelected(medias.filter(function (i) {
          return i.mediaType === "image";
        })[newIndex]);
      },
      onNext: function onNext() {
        var selectedItemIndex = medias.filter(function (i) {
          return i.mediaType === "image";
        }).findIndex(function (i) {
          return i.id === (mediaModalSelected === null || mediaModalSelected === void 0 ? void 0 : mediaModalSelected.id);
        });
        var newIndex = selectedItemIndex + 1 > medias.filter(function (i) {
          return i.mediaType === "image";
        }).length - 1 ? 0 : selectedItemIndex + 1;
        setMediaModalSelected(medias.filter(function (i) {
          return i.mediaType === "image";
        })[newIndex]);
      }
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_17___default().create({
  container: {
    alignSelf: "stretch",
    paddingBottom: 16
  },
  profileTagContainer: {
    marginTop: 8
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  }
});
/* harmony default export */ __webpack_exports__["default"] = (MediaListContainer);

/***/ }),

/***/ 74157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modals_MediaModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./node_modules/react-swipeable/es/index.js
var es = __webpack_require__(45338);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/profile/modals/MediaModal/MediaContainer.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var MediaContainer = function MediaContainer(props) {
  var isMobileVersion = props.isMobileVersion,
      item = props.item,
      onPrev = props.onPrev,
      onNext = props.onNext;
  var handlers = (0,es/* useSwipeable */.QS)({
    onSwipedLeft: function onSwipedLeft(eventData) {
      onNext();
    },
    onSwipedRight: function onSwipedRight(eventData) {
      onPrev();
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* Media */.pU, {
      style: {
        marginTop: isMobileVersion ? 0 : 30
      },
      isAutoHeight: true,
      width: isMobileVersion ? config/* Values.deviceWidth */.$m.deviceWidth - 100 : 870,
      height: isMobileVersion ? 600 : 600,
      item: item,
      isPlay: true,
      isFull: true
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _objectSpread(_objectSpread({}, handlers), {}, {
      className: "absolute z-10 h-full w-full flex flex-row justify-between items-center px-[15px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: onPrev,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: isMobileVersion ? "/icons/ic_arrow_left_white.png" : "/icons/ic_arrow_left.png",
          width: "40",
          height: "40",
          alt: "arrow"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: onNext,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: isMobileVersion ? "/icons/ic_arrow_right_white.png" : "/icons/ic_arrow_right.png",
          width: "40",
          height: "40",
          alt: "arrow"
        })
      })]
    }))]
  });
};

var styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  }
});
/* harmony default export */ var MediaModal_MediaContainer = (MediaContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/MediaModal/index.js


function MediaModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MediaModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MediaModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MediaModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var MediaModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, MediaModal_objectSpread(MediaModal_objectSpread({
    ref: ref
  }, props), {}, {
    modalType: config/* Constants.modalType.MODAL_TYPE_CENTER */.gT.modalType.MODAL_TYPE_CENTER,
    closableWithOutsideTouch: true,
    maxWidth: isMobileVersion ? config/* Values.deviceWidth */.$m.deviceWidth : 1070 // hideClose
    ,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MediaModal_MediaContainer, MediaModal_objectSpread(MediaModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction,
      isMobileVersion: isMobileVersion
    }))
  }));
});
/* harmony default export */ var modals_MediaModal = (MediaModal);

/***/ })

}]);